import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Select from 'react-select'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk } from 'helpers/api'
import { checkFilter, chequeDates, formatDate, formatMoney, getCurrentChequeDate } from 'helpers/helpers'
import ReactApexChart from 'react-apexcharts'
import CustomTooltip from 'pages/parts/CustomTooltip'

function Dashboard() {
	const { t } = useTranslation();
	const date = new Date()

	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: '',
		activeTab: 'sales',
	}

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(true)
	const [expensesModal, setExpensesModal] = useState({ show: false })

	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [data, setData] = useState({})
	const [showComponent, setShowComponent] = useState({
		'paymentType': 'table',
		'expenseType': 'table',
		'incomeType': 'table',

		'orderType': 'table',
		'menuType': 'table',
		'productType': 'table',
		'hallType': 'table',
		'tableType': 'table',
		'waiterType': 'table',
	})

	const [chartSales, setChartSales] = useState({
		series: [
			{
				name: t('sales'),
				data: [],
				yAxis: 0
			},
			{
				name: t('cheques'),
				data: [],
				yAxis: 1
			}
		],
		options: {
			colors: ['#34c38f', '#f1b44c'],
			chart: {
				height: 350,
				type: 'line',
				toolbar: {
					show: false
				},
				background: '#fff',
			},
			legend: {
				show: false
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'straight'
			},
			markers: {
				size: 5,
				colors: undefined,
				strokeWidth: 0,
				shape: "circle",
			},
			yaxis: [
				{
					title: { text: t('sales') },
					labels: {
						formatter: value => formatMoney(value, 0)
					}
				},
				{
					opposite: true,
					title: { text: t('cheques') },
					labels: {
						formatter: value => formatMoney(value, 0)
					}
				}
			],
			xaxis: {
				tooltip: {
					enabled: false
				},
				categories: [],
				labels: {
					formatter: function (value) {
						return value;
					}
				}
			},
			tooltip: {
			},
		},
	});
	const [chartIncomes, setChartIncomes] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				position: 'left',
				show: true
			},
			dataLabels: {
				enabled: true
			},
			stroke: {
				curve: 'smooth'
			},
		},
	});
	const [chartExpenses, setChartExpenses] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				show: true,
				position: 'left',
				fontSize: '14px',
				itemMargin: {
					horizontal: 0,
					vertical: 0
				},
				markers: {
					width: 0,
					height: 0
				},
				formatter: function (seriesName, opts) {
					const value = opts.w.globals.series[opts.seriesIndex];
					const color = opts.w.globals.colors[opts.seriesIndex];
					const formatted = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

					return `
						<div style="display: flex; flex-direction: column; align-items: flex-start; line-height: 1.2;">
							<div style="display: flex; align-items: center;">
								<span style="
									display:inline-block;
									width:10px;
									height:10px;
									border-radius:50%;
									background:${color};
									margin-right:8px;">
								</span>
								<span>${seriesName}</span>
							</div>
							<div style="margin-left:18px; font-weight: bold;">${formatted}</div>
						</div>
					`;
				},
				labels: {
					useSeriesColors: false
				}
			},
			dataLabels: {
				enabled: true
			},
			stroke: {
				curve: 'smooth'
			},
		},
	});
	const [chartPaymentTypes, setChartPaymentTypes] = useState({
		series: [],
		options: {
			chart: {
				width: 380,
				type: 'pie',
				toolbar: {
					show: false
				},
			},
			labels: [],
			legend: {
				show: true,
				position: 'left',
				fontSize: '14px',
				itemMargin: {
					horizontal: 0,
					vertical: 0
				},
				markers: {
					width: 0,
					height: 0
				},
				formatter: function (seriesName, opts) {
					const value = opts.w.globals.series[opts.seriesIndex];
					const color = opts.w.globals.colors[opts.seriesIndex];
					const formatted = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

					return `
						<div style="display: flex; flex-direction: column; align-items: flex-start; line-height: 1.2;">
							<div style="display: flex; align-items: center;">
								<span style="
									display:inline-block;
									width:10px;
									height:10px;
									border-radius:50%;
									background:${color};
									margin-right:8px;">
								</span>
								<span>${seriesName}</span>
							</div>
							<div style="margin-left:18px; font-weight: bold;">${formatted}</div>
						</div>
					`;
				},
				labels: {
					useSeriesColors: false
				}
			},
			dataLabels: {
				enabled: true,
			},
			stroke: {
				curve: 'smooth',
			},
		},
	});
	const [chartCategories, setChartCategories] = useState({
		series: [{
			name: t('amount'),
			data: []
		}],
		options: {
			chart: {
				type: 'bar',
				height: 350
			},
			plotOptions: {
				bar: {
					borderRadius: 4,
					borderRadiusApplication: 'end',
					horizontal: true,
				}
			},
			dataLabels: {
				enabled: false
			},
			xaxis: {
				categories: [],
			}
		},
	});
	const [chartProducts, setChartProducts] = useState({
		series: [{
			name: t('amount'),
			data: []
		}],
		options: {
			chart: {
				type: 'bar',
				height: 350
			},
			plotOptions: {
				bar: {
					borderRadius: 4,
					borderRadiusApplication: 'end',
					horizontal: true,
				}
			},
			dataLabels: {
				enabled: false
			},
			xaxis: {
				categories: [],
			}
		},
	});

	async function toggleExpenseModal(bool, item) {
		if (bool) {
			const response = await GET(`/expenses`, { ...filterData, payment_purpose_id: item.id });
			if (httpOk(response)) {
				setExpensesModal({ show: bool, ...response.data, item: item })
			}
		} else {
			setExpensesModal({ show: false })
		}
	}

	function resetFilter() {
		setFilterData({ ...initialFilter })
		getData();
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id })
	}

	async function getData() {
		setFilterDataExist(checkFilter(filterData, initialFilter));

		const response = await GET("/report/dashboard-sales", filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			if (filterData.activeTab === 'sales') {
				var chartSalesCopy = { ...chartSales }

				chartSalesCopy.series[0]['data'] = response.data.chart_sales['series_sales']
				chartSalesCopy.series[1]['data'] = response.data.chart_sales['series_cheqeus']
				chartSalesCopy.options.xaxis.categories = response.data.chart_sales['series_dates']

				setChartSales(chartSalesCopy)
			}

			if (filterData.activeTab === 'finance') {
				var chartPaymentTypesCopy = { ...chartPaymentTypes }
				var chartExpensesCopy = { ...chartExpenses }
				var chartIncomesCopy = { ...chartIncomes }

				chartPaymentTypesCopy.series = response.data.payment_types.chart.series
				chartPaymentTypesCopy.options.labels = response.data.payment_types.chart.categories

				chartExpensesCopy.series = response.data.expenses.chart.series
				chartExpensesCopy.options.labels = response.data.expenses.chart.categories

				chartIncomesCopy.series = response.data.incomes.chart.series
				chartIncomesCopy.options.labels = response.data.incomes.chart.categories

				setChartIncomes(chartIncomesCopy)
				setChartExpenses(chartExpensesCopy)
				setChartPaymentTypes(chartPaymentTypesCopy)
			}
			if (filterData.activeTab === 'top') {
				var chartCategoriesCopy = { ...chartCategories }
				var chartProductsCopy = { ...chartProducts }

				chartCategoriesCopy.series[0]['data'] = response.data.categories.chart.series
				chartCategoriesCopy.options.xaxis.categories = response.data.categories.chart.categories

				chartProductsCopy.series[0]['data'] = response.data.products.chart.series
				chartProductsCopy.options.xaxis.categories = response.data.products.chart.categories

				setChartCategories(chartCategoriesCopy)
				setChartProducts(chartProductsCopy)
			}


			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		getData()
	}, [filterData.activeTab]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('home')}
				</h4>
			</div>

			<div >
				<div style={{ minHeight: '85vh' }}>
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>

							<button className={`btn btn-wide-2 ${filterData.activeTab === 'sales' ? 'btn-primary' : 'btn-outline-primary'}`}
								style={{ 'width': '100px' }}
								onClick={() => setFilterData({ ...filterData, 'activeTab': 'sales' })}>
								{t('sales')}
							</button>
							<button className={`btn btn-wide-2 ${filterData.activeTab === 'finance' ? 'btn-primary' : 'btn-outline-primary'}`}
								style={{ 'width': '100px' }}
								onClick={() => setFilterData({ ...filterData, 'activeTab': 'finance' })}>
								{t('finance')}
							</button>
							<button className={`btn btn-wide-2 ${filterData.activeTab === 'top' ? 'btn-primary' : 'btn-outline-primary'}`}
								style={{ 'width': '100px' }}
								onClick={() => setFilterData({ ...filterData, 'activeTab': 'top' })}>
								{t('top')}
							</button>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					{filterData.activeTab === 'sales' &&
						<div className="row">
							<div className="col-md-4">
								<div className="dashboard-cards">
									<div className="dashboard-card">
										<div className="title">
											{t('cheques')}
										</div>
										<div className="value">
											{formatMoney(data.total_cheques)}
										</div>
									</div>
									<div className="dashboard-card">
										<div className="title">
											{t('deleted_cheques')}
										</div>
										<div className="value">
											{formatMoney(data.total_deleted_cheques)}
										</div>
									</div>
								</div>
								<div className="dashboard-cards">
									<div className="dashboard-card">
										<div className="title">
											{t('closed_cheques')}
										</div>
										<div className="value">
											{formatMoney(data.total_closed_cheques)}
										</div>
									</div>
									<div className="dashboard-card">
										<div className="title">
											{t('opened_cheques')}
										</div>
										<div className="value">
											{formatMoney(data.total_open_cheques)}
										</div>
									</div>
								</div>
								<div className="dashboard-cards">
									<div className="dashboard-card">
										<div className="title">
											{t('products')}
										</div>
										<div className="value">
											{formatMoney(data.total_products)}
										</div>
									</div>
									<div className="dashboard-card">
										<div className="title">
											{t('deleted_products')}
										</div>
										<div className="value">
											{formatMoney(data.total_deleted_products)}
										</div>
									</div>
								</div>
								<div className="dashboard-cards">
									<div className="dashboard-card">
										<div className="title">
											{t('average_check')}
										</div>
										<div className="value">
											{formatMoney(data.average_cheque_amount)}
										</div>
									</div>
									<div className="dashboard-card">
										<div className="title">
											{t('check_depth')}
										</div>
										<div className="value">
											{formatMoney(data.average_cheque_depth)}
										</div>
									</div>
								</div>
								<div className="dashboard-cards">
									<div className="dashboard-card">
										<div className="title">
											{t('gross_income')}
										</div>
										<div className="value">
											{formatMoney(data.gross_income)}
										</div>
									</div>
									<div className="dashboard-card">
										<div className="title">
											{t('discount')}
										</div>
										<div className="value">
											{formatMoney(data.total_discount)}
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-8">
								<div className="card">
									<div className="card-body">
										<div className="d-flex justify-content-between">
											<h4>{t('sales')}</h4>
										</div>
										<hr />
										<ReactApexChart
											key={JSON.stringify(chartSales.series)}
											options={chartSales.options}
											series={chartSales.series}
											type="line"
											height={300}
										/>
									</div>
								</div>

							</div>
						</div>
					}
					{filterData.activeTab === 'finance' &&
						<div>
							<div className="d-flex gap-2 mb-3">
								{data?.accounts?.map((item, index) => (
									<div className="dashboard-card" key={index}>
										<div className="title">
											{item.name}
										</div>
										<div className="value">
											{formatMoney(item.balance)}
										</div>
									</div>
								))}
							</div>

							<div className="d-flex gap-2">
								<div className="card" style={{ 'width': '33.3%', 'height': '60vh' }}>
									<div className="card-body">
										<div className="d-flex justify-content-between">
											<h5>{t('payment_types')}</h5>
											<h5>{formatMoney(data?.payment_types?.total_amount)}</h5>
										</div>
										<div className="dashboard-icons d-flex mt-2">
											<div className={"tab " + (showComponent.paymentType === 'table' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'paymentType': 'table' })}>
												<i className="uil uil-list-ul"></i>
											</div>
											<div className={"tab " + (showComponent.paymentType === 'chart' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'paymentType': 'chart' })}>
												<i className="uil uil-chart-pie-alt"></i>
											</div>
										</div>
										{showComponent.paymentType === 'table' ?
											<div className="table-responsive table-fixed mt-3" style={{ 'height': '50vh', 'overflow': 'auto' }}>
												<table className="table table-bordered table-hover mb-0">
													<thead>
														<tr>
															<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
															<th style={{ 'width': '100%' }}>{t('name2')}</th>
															<th style={{ 'minWidth': '80px' }} className="text-end">{t('quantity')}</th>
															<th style={{ 'minWidth': '120px' }} className="text-end">{t('amount')}</th>
															<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
														</tr>
													</thead>
													<tbody>
														{data?.payment_types?.data?.map((item, index) => (
															<tr key={index}>
																<td className="text-center">{index + 1}</td>
																<td className="td-ellipsis" title={item.name}>
																	{item.name}
																</td>
																<td className="text-end">{formatMoney(item.total_quantity)}</td>
																<td className="text-end">{formatMoney(item.total_amount)}</td>
																<td className="text-end">{formatMoney(item.percentage, 2)}</td>
															</tr>
														))}
														<tr>
															<td></td>
															<td><b>{t('total')}</b></td>
															<td className="text-end"><b>{formatMoney(data?.payment_types?.total_quantity)}</b></td>
															<td className="text-end"><b>{formatMoney(data?.payment_types?.total_amount)}</b></td>
															<td className="text-end"><b>100</b></td>
														</tr>
													</tbody>
												</table>
											</div>
											:
											<ReactApexChart
												key={JSON.stringify(chartPaymentTypes.series)}
												type="pie"
												height={350}
												series={chartPaymentTypes.series}
												options={chartPaymentTypes.options}
											/>
										}
									</div>
								</div>
								<div className="card" style={{ 'width': '33.3%', 'height': '60vh' }}>
									<div className="card-body">
										<div className="d-flex justify-content-between">
											<h5>{t('expense')}</h5>
											<h5>{formatMoney(data?.expenses?.total_amount)}</h5>
										</div>
										<div className="dashboard-icons d-flex mt-2">
											<div className={"tab " + (showComponent.expenseType === 'table' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'expenseType': 'table' })}>
												<i className="uil uil-list-ul"></i>
											</div>
											<div className={"tab " + (showComponent.expenseType === 'chart' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'expenseType': 'chart' })}>
												<i className="uil uil-chart-pie-alt"></i>
											</div>
										</div>
										{showComponent.expenseType === 'table' ?
											<div className="table-responsive table-fixed mt-3" style={{ 'height': '50vh', 'overflow': 'auto' }}>
												<table className="table table-bordered table-hover mb-0">
													<thead>
														<tr>
															<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
															<th style={{ 'width': '100%' }}>{t('name2')}</th>
															<th style={{ 'minWidth': '80px' }} className="text-end">{t('quantity')}</th>
															<th style={{ 'minWidth': '120px' }} className="text-end">{t('amount')}</th>
															<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
														</tr>
													</thead>
													<tbody>
														{data?.expenses?.data?.map((item, index) => (
															<tr className="cursor" key={index} onClick={() => toggleExpenseModal(true, item, 'minus')}>
																<td className="text-center">{index + 1}</td>
																<td className="td-ellipsis" title={item.name}>
																	{item.name}
																</td>
																<td className="text-end">{formatMoney(item.total_quantity)}</td>
																<td className="text-end">{formatMoney(item.total_amount)}</td>
																<td className="text-end">{formatMoney(item.percentage, 2)}</td>
															</tr>
														))}
													</tbody>
													<tfoot>
														<tr>
															<td></td>
															<td><b>{t('total')}</b></td>
															<td className="text-end"><b>{formatMoney(data?.expenses?.total_quantity)}</b></td>
															<td className="text-end"><b>{formatMoney(data?.expenses?.total_amount)}</b></td>
															<td className="text-end"><b>100</b></td>
														</tr>
													</tfoot>
												</table>
											</div>
											:
											<ReactApexChart
												key={JSON.stringify(chartExpenses.series)}
												type="pie"
												height={350}
												series={chartExpenses.series}
												options={chartExpenses.options}
											/>
										}
									</div>
								</div>
								<div className="card" style={{ 'width': '33.3%', 'height': '60vh' }}>
									<div className="card-body">
										<div className="d-flex justify-content-between">
											<h5>{t('income')}</h5>
											<h5>{formatMoney(data?.incomes?.total_amount)}</h5>
										</div>
										<div className="dashboard-icons d-flex mt-2">
											<div className={"tab " + (showComponent.incomeType === 'table' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'incomeType': 'table' })}>
												<i className="uil uil-list-ul"></i>
											</div>
											<div className={"tab " + (showComponent.incomeType === 'chart' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'incomeType': 'chart' })}>
												<i className="uil uil-chart-pie-alt"></i>
											</div>
										</div>
										{showComponent.incomeType === 'table' ?
											<div className="table-responsive table-fixed mt-3" style={{ 'height': '50vh', 'overflow': 'auto' }}>
												<table className="table table-bordered table-hover mb-0">
													<thead>
														<tr>
															<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
															<th style={{ 'width': '100%' }}>{t('name2')}</th>
															<th style={{ 'minWidth': '80px' }} className="text-end">{t('quantity')}</th>
															<th style={{ 'minWidth': '120px' }} className="text-end">{t('amount')}</th>
															<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
														</tr>
													</thead>
													<tbody>
														{data?.incomes?.data?.map((item, index) => (
															<tr className="cursor" key={index} onClick={() => toggleExpenseModal(true, item, 'plus')}>
																<td className="text-center">{index + 1}</td>
																<td className="td-ellipsis" title={item.name}>
																	{item.name}
																</td>
																<td className="text-end">{formatMoney(item.total_quantity)}</td>
																<td className="text-end">{formatMoney(item.total_amount)}</td>
																<td className="text-end">{formatMoney(item.percentage, 2)}</td>
															</tr>
														))}
														<tr>
															<td></td>
															<td><b>{t('total')}</b></td>
															<td className="text-end"><b>{formatMoney(data?.incomes?.total_quantity)}</b></td>
															<td className="text-end"><b>{formatMoney(data?.incomes?.total_amount)}</b></td>
															<td className="text-end"><b>100</b></td>
														</tr>
													</tbody>
												</table>
											</div>
											:
											<ReactApexChart
												key={JSON.stringify(chartIncomes.series)}
												type="pie"
												height={350}
												series={chartIncomes.series}
												options={chartIncomes.options}
											/>
										}
									</div>
								</div>
							</div>

						</div>
					}
					{filterData.activeTab === 'top' &&
						<div>
							<div className="d-flex gap-2">
								<div className="card mb-2" style={{ 'width': '33.3%', 'height': '480px' }}>
									<div className="card-body">
										<div className="d-flex justify-content-between">
											<h5>{t('menu')}</h5>
											<h5>{formatMoney(data?.categories?.total_amount)}</h5>
										</div>
										<div className="dashboard-icons d-flex mt-2">
											<div className={"tab " + (showComponent.menuType === 'table' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'menuType': 'table' })}>
												<i className="uil uil-list-ul"></i>
											</div>
											<div className={"tab " + (showComponent.menuType === 'chart' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'menuType': 'chart' })}>
												<i className="uil uil-chart-pie-alt"></i>
											</div>
										</div>
										{showComponent.menuType === 'table' ?
											<div className="table-responsive table-fixed mt-3" style={{ 'height': '370px', 'overflow': 'auto' }}>
												<table className="table table-bordered table-hover mb-0">
													<thead>
														<tr>
															<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
															<th style={{ 'width': '100%' }}>{t('name2')}</th>
															<th style={{ 'minWidth': '80px' }} className="text-end">{t('quantity')}</th>
															<th style={{ 'minWidth': '120px' }} className="text-end">{t('amount')}</th>
															<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
														</tr>
													</thead>
													<tbody>
														{data?.categories?.data?.map((item, index) => (
															<tr key={index}>
																<td className="text-center">{index + 1}</td>
																<td className="td-ellipsis" title={item.name}>
																	{item.name}
																</td>
																<td className="text-end">{formatMoney(item.total_quantity)}</td>
																<td className="text-end">{formatMoney(item.total_amount)}</td>
																<td className="text-end">{formatMoney(item.percentage, 2)}</td>
															</tr>
														))}
														<tr>
															<td></td>
															<td><b>{t('total')}</b></td>
															<td className="text-end"><b>{formatMoney(data?.categories?.total_quantity)}</b></td>
															<td className="text-end"><b>{formatMoney(data?.categories?.total_amount)}</b></td>
															<td className="text-end"><b>100</b></td>
														</tr>
													</tbody>
												</table>
											</div>
											:
											<ReactApexChart
												key={JSON.stringify(chartCategories.series)}
												type="bar"
												height={370}
												series={chartCategories.series}
												options={chartCategories.options}
											/>
										}
									</div>
								</div>
								<div className="card mb-2" style={{ 'width': '33.3%', 'height': '480px' }}>
									<div className="card-body">
										<div className="d-flex justify-content-between">
											<h5>{t('products')}</h5>
											<h5>{formatMoney(data?.products?.total_amount)}</h5>
										</div>
										<div className="dashboard-icons d-flex mt-2">
											<div className={"tab " + (showComponent.productType === 'table' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'productType': 'table' })}>
												<i className="uil uil-list-ul"></i>
											</div>
											<div className={"tab " + (showComponent.productType === 'chart' ? 'active' : '')}
												onClick={() => setShowComponent({ ...showComponent, 'productType': 'chart' })}>
												<i className="uil uil-chart-pie-alt"></i>
											</div>
										</div>
										{showComponent.productType === 'table' ?
											<div className="table-responsive table-fixed mt-3" style={{ 'height': '370px', 'overflow': 'auto' }}>
												<table className="table table-bordered table-hover mb-0">
													<thead>
														<tr>
															<th className="text-center" style={{ 'minWidth': '33px' }}>#</th>
															<th style={{ 'width': '100%' }}>{t('name2')}</th>
															<th style={{ 'minWidth': '80px' }} className="text-end">{t('quantity')}</th>
															<th style={{ 'minWidth': '120px' }} className="text-end">{t('amount')}</th>
															<th style={{ 'minWidth': '50px' }} className="text-end">%</th>
														</tr>
													</thead>
													<tbody>
														{data?.products?.data?.map((item, index) => (
															<tr key={index}>
																<td className="text-center">{index + 1}</td>
																<td className="td-ellipsis" title={item.name}>
																	{item.name}
																</td>
																<td className="text-end">{formatMoney(item.total_quantity)}</td>
																<td className="text-end">{formatMoney(item.total_amount)}</td>
																<td className="text-end">{formatMoney(item.percentage, 2)}</td>
															</tr>
														))}
														<tr>
															<td></td>
															<td><b>{t('total')}</b></td>
															<td className="text-end"><b>{formatMoney(data?.products?.total_quantity)}</b></td>
															<td className="text-end"><b>{formatMoney(data?.products?.total_amount)}</b></td>
															<td className="text-end"><b>100</b></td>
														</tr>
													</tbody>
												</table>
											</div>
											:
											<ReactApexChart
												key={JSON.stringify(chartProducts.series)}
												type="bar"
												height={370}
												series={chartProducts.series}
												options={chartProducts.options}
											/>
										}
									</div>
								</div>
							</div>
						</div>
					}
				</div>
			</div>

			<Modal show={expensesModal.show} animation={false} centered size="xl"
				dialogClassName="expense-modal" onHide={() => toggleExpenseModal(false)}>
				<Modal.Header closeButton className="d-flex gap-2">
					<Modal.Title className="d-flex align-items-center gap-2">
						{expensesModal?.item?.name} [{expensesModal?.total_quantity}]
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>


					<table className="table table-bordered">
						<thead>
							<tr>
								<th style={{ minWidth: '33px' }}>#</th>
								<th style={{ width: '20%' }} className="td-ellipsis">{t('name')}</th>
								<th style={{ width: '10%' }} className="td-ellipsis">{t('payment_type')}</th>
								<th style={{ width: '20%' }} className="td-ellipsis">{t('client')}</th>
								<th style={{ width: '30%' }} className="td-ellipsis">{t('note')}</th>
								<th style={{ minWidth: '130px' }} className="text-center">{t('date')}</th>
								<th style={{ minWidth: '120px' }} className="text-end td-ellipsis">{t('amount')}</th>
							</tr>
						</thead>
						<tbody>
							{expensesModal?.data?.map((item, index) => (
								<tr key={index}>
									<td>{index + 1}</td>
									<td className="td-ellipsis">
										<CustomTooltip text={item.name}>
											{item.name}
										</CustomTooltip>
									</td>
									<td>{item.payment_name}</td>
									<td>{item.client_name}</td>
									<td>
										<CustomTooltip text={item.note}>
											{item.note}
										</CustomTooltip>
									</td>
									<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
									<td className={`text-end ${item.transaction_type === 'plus' ? 'text-success' : 'text-danger'}`}>{formatMoney(item.amount)}</td>
								</tr>
							))
							}
						</tbody>
						<tfoot>
							<tr className="tr-bold">
								<td>{t('total')}</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td className="text-end">{formatMoney(expensesModal.total_amount)}</td>
							</tr>
						</tfoot>
					</table>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Dashboard